import { useLocation, useNavigate } from 'react-router-dom';
import * as MUI from '@mui/material';

import IconHome from '@mui/icons-material/Home';

const MenuItem = (props) => (
	<MUI.ListItem button onClick={props.onClick} disabled={props.disabled}>
		<MUI.ListItemIcon sx={{ minWidth: '32px' }}>{props.icon}</MUI.ListItemIcon>
		<MUI.ListItemText primary={props.name} />
	</MUI.ListItem>
);

export default function Sidebar() {
	const location = useLocation();
	const navigate = useNavigate();

	const go = (url) => {
		navigate(url, {
			state: location.state,
			replace: location.search === '?leftMenu'
		});
	}

	return (<>
		<MUI.Toolbar />
		<MUI.Divider />
		<MUI.List sx={{ flex: 1 }}>
			<MenuItem onClick={() => go("/")} name="Главная" icon={(<IconHome />)} />
		</MUI.List>
	</>);
}
